/**
 * The autodialer beforeunload dialog is for accidental tab close / reload.
 * Going to the next queue task is in-session navigation — if Next.js falls
 * back to a full document load (or a recovery path used to hard-assign),
 * that must not look like leaving the workflow.
 */

let skipUntilMs = 0;

export const WORKFLOW_BEFOREUNLOAD_SKIP_MS = 2_000;

export const skipNextWorkflowBeforeUnload = (
  nowMs: number = Date.now(),
  skipForMs: number = WORKFLOW_BEFOREUNLOAD_SKIP_MS,
): void => {
  skipUntilMs = nowMs + skipForMs;
};

export const resetWorkflowBeforeUnloadSkip = (): void => {
  skipUntilMs = 0;
};

export const shouldBlockWorkflowBeforeUnload = ({
  isWorkflowActive,
  hasUserGesture,
  nowMs = Date.now(),
}: {
  isWorkflowActive: boolean;
  hasUserGesture: boolean;
  nowMs?: number;
}): boolean => {
  if (!isWorkflowActive || !hasUserGesture) {
    return false;
  }
  if (nowMs < skipUntilMs) {
    skipUntilMs = 0;
    return false;
  }
  return true;
};
